const isIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !window.MSStream;

gsap.registerPlugin(ScrollTrigger);

ScrollTrigger.create({
  trigger: ".home-hero__svg",
  start: "bottom bottom",
  end: "bottom top",
  endTrigger: "#perpetua_hero",
  scrub: true,
  pin: !isIOS,
});

document.addEventListener("DOMContentLoaded", () => {
  function setViewportHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }
  window.addEventListener("load", setViewportHeight);
  window.addEventListener("resize", setViewportHeight);

  gsap.registerPlugin(gsap.plugins.ScrollToPlugin);

  const logo = document.getElementById("scrollToTopLogo");
  if (logo) {
    logo.addEventListener("click", (e) => {
      console.log("click en logo registrado");
      e.preventDefault();
      gsap.to("html, body", {
        scrollTo: 0,
        duration: 1,
        ease: "power2.out",
      });
    });
  }

  const hero = document.querySelector(".home-hero");

  if (hero) {
    const desktopImg = hero.dataset.imgDesktop;
    const mobileImg = hero.dataset.imgMobile;

    const applyHeroImage = () => {
      const isMobile = window.innerWidth <= 900;
      const currentImg = isMobile ? mobileImg : desktopImg;
      if (currentImg) {
        hero.style.backgroundImage = `url("${currentImg}")`;
      }
    };

    applyHeroImage();
    window.addEventListener("resize", applyHeroImage);
  }

  const slider = document.querySelector(".home-projects-slider");
  if (!slider) return;

  const rawData = slider.getAttribute("data-projects");
  let data = [];

  try {
    data = JSON.parse(rawData);
  } catch (e) {
    console.error("Error parsing project data:", e);
    return;
  }

  if (!data.length) return;

  let currentIndex = 0;

  const imgEl = slider.querySelector(".home-projects-slider-image img");
  const idEl = document.getElementById("project-id");
  const collectionEl = document.getElementById("project-collection");
  const nameEl = document.getElementById("project-name");
  const yearEl = document.getElementById("project-year");
  const paginationEl = slider.querySelector(".home-projects-slider-pagination");

  const prevBtn = slider.querySelector(".home-projects-slider-prev");
  const nextBtn = slider.querySelector(".home-projects-slider-next");
  const imageContainer = slider.querySelector(".home-projects-slider-image");

  prevBtn.addEventListener("click", () => {
    if (currentIndex > 0) {
      currentIndex -= 1;
      updateSlider(currentIndex);
    }
  });

  nextBtn.addEventListener("click", () => {
    if (currentIndex < data.length - 1) {
      currentIndex += 1;
      updateSlider(currentIndex);
    }
  });

  // function updateSlider(index) {
  //   const project = data[index];

  //   imgEl.classList.add("fade-out");
  //   idEl.classList.add("fade-out");
  //   collectionEl.classList.add("fade-out");
  //   nameEl.classList.add("fade-out");
  //   yearEl.classList.add("fade-out");
  //   paginationEl.classList.add("fade-out");

  //   setTimeout(() => {
  //     imgEl.src = project.image;
  //     idEl.textContent = project.id;
  //     collectionEl.textContent = project.collection;
  //     nameEl.textContent = project.name;
  //     yearEl.textContent = project.year;
  //     paginationEl.textContent = `${index + 1} / ${data.length}`;

  //     imgEl.classList.remove("fade-out");
  //     idEl.classList.remove("fade-out");
  //     collectionEl.classList.remove("fade-out");
  //     nameEl.classList.remove("fade-out");
  //     yearEl.classList.remove("fade-out");
  //     paginationEl.classList.remove("fade-out");
  //   }, 300);
  // }

  function updateSlider(index) {
    const project = data[index];

    imgEl.classList.add("fade-out");
    idEl.classList.add("fade-out");
    collectionEl.classList.add("fade-out");
    nameEl.classList.add("fade-out");
    yearEl.classList.add("fade-out");
    paginationEl.classList.add("fade-out");

    setTimeout(() => {
      imgEl.src = project.image;
      idEl.textContent = project.data;
      collectionEl.textContent = project.collection;
      nameEl.textContent = project.name;
      yearEl.textContent = project.year;
      paginationEl.textContent = `${index + 1} / ${data.length}`;

      imgEl.classList.remove("fade-out");
      idEl.classList.remove("fade-out");
      collectionEl.classList.remove("fade-out");
      nameEl.classList.remove("fade-out");
      yearEl.classList.remove("fade-out");
      paginationEl.classList.remove("fade-out");

      prevBtn.classList.toggle("is-disabled", index === 0);
      nextBtn.classList.toggle("is-disabled", index === data.length - 1);
    }, 300);
  }

  // prevBtn.addEventListener("click", () => {
  //   currentIndex = (currentIndex - 1 + data.length) % data.length;
  //   updateSlider(currentIndex);
  // });

  // nextBtn.addEventListener("click", () => {
  //   currentIndex = (currentIndex + 1) % data.length;
  //   updateSlider(currentIndex);
  // });

  updateSlider(currentIndex);

  imageContainer.addEventListener("click", (e) => {
    e.stopPropagation();
    const project = data[currentIndex];
    if (project.url) {
      window.location.href = project.url;
    }
  });
});
